import React from "react";
import { ComidaCard } from "../comidas/ComidaCard";
import { contarAsistentes } from "./eventosUtils";

export const EventoComidaCard = ({ evento, opTrabajadores, onChange }) => (
	<div className="events-card-frame events-type-food">
		<ComidaCard
			data={evento}
			totalAsistentes={contarAsistentes(evento)}
			opTrabajadores={opTrabajadores}
			setSuccesCrearComida={onChange}
		/>
	</div>
);
